import BaseStimulusModelController from "../../../BaseStimulusModelController";
import { OnboardingStimulusModel } from "../../../../scripts/_generated/OnboardingStimulusModel";
import Shepherd from "shepherd.js";
import 'shepherd.js/dist/css/shepherd.css';
import './Onboarding.scss';
import { EventHandlerRegistration, registerGlobalEventHandlerEventName } from "../../../../scripts/BodyController";

export default class OnboardingController extends BaseStimulusModelController<OnboardingStimulusModel>  {
    
    tour: Shepherd.Tour | undefined;

    connect() {
        this.initializeOnboarding();
    }

    initializeOnboarding() {
        if (!this.modelValue.shouldEnableOnboarding) return;

        const isDisableOnboardingCookiePresent = document.cookie.split(';').findIndex(x => x.startsWith('_SMG_onboarding_disabled=')) >= 0;
        if (isDisableOnboardingCookiePresent) return;

        const tour = new Shepherd.Tour({
            useModalOverlay: true,
            defaultStepOptions: {
                cancelIcon: {
                    enabled: true
                },
                classes: "shadow-md bg-purple-dark",
                scrollTo: true
            }
        });

        this.tour = tour;

        this.modelValue.steps.forEach((step, i) => {
            
            const buttons: Shepherd.Step.StepOptionsButton[] = [];

            if (i > 0) {
                buttons.push({
                    text: "Back",
                    action: tour.back
                });
            }

            if (i < this.modelValue.steps.length - 1) {
                buttons.push({
                    text: "Next",
                    action: tour.next
                });
            }

            if (i == this.modelValue.steps.length - 1) {
                buttons.push({
                    text: "Done",
                    action: tour.complete
                });
            }

            tour.addStep({
                title: step.title,
                text: step.text,
                attachTo: {
                    element: () => {
                        var el = document.querySelector(step.elementIdentifier);
                        if (!el) return null;
    
                        // @ts-ignore
                        if (el.offsetParent !== null) { // is visible; more info https://stackoverflow.com/a/21696585/379279
                            return step.elementIdentifier;
                        }
                        else {
                            const mainMenu = el.closest("#main-menu");
                            if (mainMenu && !mainMenu.classList.contains("show")) {
                                const mainMenuToggleButton = document.getElementById("mainMenuToggleButton");
                                if (!mainMenuToggleButton) throw new Error("Cannot find main menu toggle button.")
                                mainMenuToggleButton.click();
                                el = document.querySelector(step.elementIdentifier);
                                // @ts-ignore
                                if (el.offsetParent !== null) {
                                    return step.elementIdentifier;
                                }
                            }
                            return null;
                        }
                    },
                    on: "auto"
                },
                buttons: buttons,
                canClickTarget: false
            });
        });

        tour.on("cancel", async () => {
            await this.completeOnboarding();
        });

        tour.on("complete", async () => {
            await this.completeOnboarding();
        });

        if (this.modelValue.shouldStartOnboardingImmediately) {
            this.startOnboarding();
        } else {
            this.registerStartOnboardingEventHandler();
        }
    }

    registerStartOnboardingEventHandler() {
        this.dispatch(registerGlobalEventHandlerEventName, {
            prefix: "",
            detail: new EventHandlerRegistration<string[]>(this.modelValue.startOnboardingOnEvent, this.startOnboarding.bind(this))
        });
    }

    async completeOnboarding() {
        const response = await fetch(this.modelValue.completeOnboardingUrl, { method: "POST" });
        if (!response.ok) throw new Error("Completing onboarding failed.");

        if (!this.tour) throw new Error(`Onboarding ${this.modelValue.onboardingIdentifier} is not initialized.`);
        this.tour.steps.forEach(step => {
            step.destroy();
        });
        this.tour = undefined;
    }

    startOnboarding() {
        if (!this.tour) return;

        if (Shepherd.activeTour) return;

        this.tour.start();
    }
}

export function refreshActiveOnboardingStepPosition() {
    if (Shepherd.activeTour) {
        const activeTourCurrentStep = Shepherd.activeTour.getCurrentStep();
        if (activeTourCurrentStep) {
            // @ts-ignore
            activeTourCurrentStep.tooltip.update(); // tooltip property of type Popper is not accessible by default
        }
    }
}
